import { z } from 'zod';

export const changeUnexpectedPaymentOutcomePostRequestSchema = z.object({ reference: z.string(), value: z.string() });
